import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, List, Icon, Message } from 'semantic-ui-react';
import i18next from 'i18next';

import DeliveriesListItem from '../../deliveries-list-item/DeliveriesListItem';
import DeliveriesEditListItem from '../../deliveries-edit-list-item/DeliveriesEditListItem';

import './DeliveriesPane.scss';

class DeliveriesPane extends Component {

    constructor(props) {
        super(props);

        this.isAnyAreaBeingEdited = this.isAnyAreaBeingEdited.bind(this);
    }

    isAnyAreaBeingEdited() {
        return Object.values(this.props.areasStatus).some(area => {
            return area.edit;
        });
    }

    renderDeliveryAreaItem(index, area, areActionsDisabled) {
        const { restaurant, editDeliveryArea, removeDeliveryArea } = this.props;

        return (
            <DeliveriesListItem key={index}
                areActionsDisabled={areActionsDisabled}
                area={area}
                currencyCode={restaurant.currencyCode}
                editDeliveryArea={editDeliveryArea}
                removeDeliveryArea={removeDeliveryArea}
               
            />
        );
    }

    renderDeliveryAreaItemInEditMode(index, area) {
        const { saveDeliveryAreaEdit, cancelDeliveryAreaEdit } = this.props;

        return (
            <DeliveriesEditListItem key={index}
                area={area}
                saveDeliveryAreaEdit={saveDeliveryAreaEdit}
                cancelDeliveryAreaEdit={cancelDeliveryAreaEdit}
               
            />
        );
    }

    renderDeliveriesList() {
        const { restaurant, areasStatus } = this.props;

        const isInEditMode = this.isAnyAreaBeingEdited();

        return restaurant.deliveryAreas.map((area, index) => {
            const isEditModeOn = areasStatus && areasStatus[area.tag] && areasStatus[area.tag].edit;

            if (isEditModeOn) {
                return this.renderDeliveryAreaItemInEditMode(index, area);
            }
            return this.renderDeliveryAreaItem(index, area, isInEditMode);
        });
    }

    render() {
        const { deliveryAreas } = this.props.restaurant;

        if (!deliveryAreas || (Array.isArray(deliveryAreas) && deliveryAreas.length === 0)) {
            return (
                <Message icon>
                    <Icon name='circle warning' />
                    <Message.Content>{i18next.t('noDeliveryAreas')}</Message.Content>
                </Message>
            );
        }

        return (
            <Container>
                <List size='large' verticalAlign='middle'>
                    {this.renderDeliveriesList()}
                </List>
            </Container>
        );
    }
}

DeliveriesPane.propTypes = {
    restaurant: PropTypes.object,
    editDeliveryArea: PropTypes.func,
    saveDeliveryAreaEdit: PropTypes.func,
    cancelDeliveryAreaEdit: PropTypes.func,
    removeDeliveryArea: PropTypes.func,
    areasStatus: PropTypes.object,
    
};

export default DeliveriesPane;
